<template>
    <modal
        class="is-narrow"
        v-bind:title="__('Are you sure?')"
        v-bind:is-open="isOpenDeleteModal"
        v-on:close-modal="close"
    >
        <template v-slot:body>
            <p
                class="has-text-center"
                v-html="
                    __(
                        'Are you sure you want to delete this campaign?<br />This action cannot be undone.'
                    )
                "
            ></p>
        </template>
        <template v-slot:footer>
            <div class="has-padding-t10">
                <div class="columns">
                    <div class="column">
                        <btn
                            class="is-block"
                            type="cancel"
                            v-html="__('Cancel')"
                            v-on:click="close"
                        >
                        </btn>
                    </div>
                    <div class="column">
                        <btn
                            class="is-block"
                            type="error"
                            v-html="__('Delete')"
                            v-on:click="deleteCampaign"
                        >
                        </btn>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import { Btn, Modal } from '@teamfurther/cinderblock';

export default {
    components: {
        Btn,
        Modal
    },
    methods: {
        close: function() {
            this.$emit('close');
        },
        deleteCampaign: function() {
            this.$emit('delete', this.id);
        }
    },
    props: {
        id: {
            required: true
        },
        isOpenDeleteModal: {
            required: true,
            type: Boolean
        }
    }
};
</script>
